import {Component, OnInit} from '@angular/core';
import {KcStatus} from '../../../services/api.client';
import {Observable} from 'rxjs';
import {SecurityService} from '../../../services/SecurityService';

@Component({
    selector: '[keepingCurrentStatus]',
    templateUrl: './KeepingCurrentStatusesDropdown.html',
    standalone: false
})
export class KeepingCurrentStatuses implements OnInit {
  keepingCurrentStatus: KcStatus[];
  keepingCurrentStatus$: Observable<KcStatus[]>;

  constructor(private _securityService: SecurityService) {
    this.keepingCurrentStatus$ = this._securityService.kcStatuses$;
  }

  ngOnInit(): void {
    this.keepingCurrentStatus$.subscribe(keepingCurrentStatus => this.keepingCurrentStatus = keepingCurrentStatus);
  }
}
